import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import SvgUpArrowIcon from '../../svg/UpArrowIcon';

function Echostream() {
  const backText = (
    <FormattedMessage
      id="support.backText"
      defaultMessage="Back to Support Tools"
      description="Link back to the users interface"
    />
  );
  return (
    <div className="container">
      <div className="layout-container content-container content-container--column content-container--shadow">
        <div className="width-100 align-center flex-around margin-bottom-10">
          <Link
            className="link-text align-center"
            to="/support/"
            data-test="user-display-cancel-link">
            <SvgUpArrowIcon className="rotate-90-ccw margin-right-10" />
            {backText}
          </Link>
        </div>
        <div className="content-display__container content-display__container--column align-center">
          <FormattedMessage
            id="echostreamTools.header"
            data-test="header-text"
            defaultMessage="Echostream Tools"
            description="The title for the page">
            {(txt) => (
              <h1
                className="no-margin text-deep-blue text-center"
                data-test="header-text-device">
                {txt}
              </h1>
            )}
          </FormattedMessage>
          <hr />
          <div
            className="content-display__container"
            data-test="content-container">
            <div
              className="content-display__column content-display__column--1-2"
              data-test="active-unit-container">
              <div className="content-display__item-pill-container">
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="echoStream.decodeToolText"
                      defaultMessage="Echostream Message Decoder"
                      description="Echostream message decode tool"
                    />
                  </div>
                  <div
                    className="item-container__secondary-text text-medium text-bold"
                    data-test="user-active-unit-link">
                    <FormattedMessage
                      id="echoStream.DecodeToolDescriptionText"
                      defaultMessage="Decode Echostream message"
                      description="Link back to the users interface"
                    />
                  </div>
                </div>
                <div className="item-container__info-container">
                  <Link
                    to="/support/echostream/decode"
                    className="link-button button-secondary button-xsm text-small margin-right-10">
                    <FormattedMessage
                      id="echoStream.DecodeToolLinkText"
                      defaultMessage="Tool"
                      description="Link back to the users interface"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="width-100 align-center flex-around margin-bottom-10">
            <Link
              className="link-text align-center"
              to="/support/"
              data-test="user-display-cancel-link">
              <SvgUpArrowIcon className="rotate-90-ccw margin-right-10" />
              {backText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Echostream;
